import { DeleteOutlined, SettingOutlined } from "@ant-design/icons";
import { Button, Col, Input, Row } from "antd";
import { DrawerLink } from "components/UI/DrawerLink";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormItem } from "react-hook-form-antd";
import { DrawerId } from "types/models";

import { FormData } from "./formSchema";

interface RequestHeadersFormProps {
    name: number;
    parentName: number;
    handleRemove: () => void;
}

export const RequestHeadersForm: FC<RequestHeadersFormProps> = ({ name, parentName, handleRemove }) => {
    const { t } = usePaldockTranslation("ui.connection-creator-editor.request-headers");
    const reqSetting = DrawerId.MethodPropertyHeaderSetting;
    const generalFormUtils = useGeneralForm<FormData>();
    const { control } = generalFormUtils;

    const headersPath = `methods.${parentName}.requestConfig.headers.${name}` as const;

    return (
        <Row gutter={16} align="middle">
            <Col span={8}>
                <FormItem control={control} name={`${headersPath}.name`} label={t("fields.key.label")} labelCol={{ span: 24 }}>
                    <Input placeholder={t("fields.key.placeholder")} />
                </FormItem>
            </Col>
            <Col span={8}>
                <FormItem control={control} name={`${headersPath}.value`} label={t("fields.value.label")} labelCol={{ span: 24 }}>
                    <Input placeholder={t("fields.value.placeholder")} />
                </FormItem>
            </Col>
            <Col style={{ textAlign: "left" }}>
                <Button danger icon={<DeleteOutlined />} onClick={handleRemove} />
            </Col>
            <Col>
                <DrawerLink
                    drawerId={reqSetting}
                    search={{
                        [`${reqSetting}-id`]: name.toString(),
                        [`${reqSetting}-parentName`]: parentName.toString(),
                    }}
                    action="show"
                >
                    <Button icon={<SettingOutlined />} />
                </DrawerLink>
            </Col>
        </Row>
    );
};
